<script>
    import {createEventDispatcher} from "svelte";

    export let options = [];
    export let inputValue;
    export let isNullable = true;
    export let externalContainerClass;
    export let containerClass;
    export let disabled = false;
    export let name;
    export let handleChange = () => {};
    export let errorText = "";

    const dispatch = createEventDispatcher();

    function handleValue(e) {
        handleChange(e);
        const value = e.target.value;
        if (!!isNullable) {
            inputValue === value ? inputValue = null : inputValue = value;
        }

        dispatch('input', { state: "switched value", value: isNullable ? inputValue : value});
    }

</script>

<div
  class="grid grid-cols-1 md:grid-flow-col min-h-[2.75rem] {externalContainerClass ?? 'gap-3'}"
  style="grid-auto-columns: minmax(0, 1fr);"
>
    {#each options as option}
        <label class="flex justify-center items-center input-home gap-2 h-11 {disabled ? 'bg-gray-100 cursor-none' : 'cursor-pointer'} {containerClass}" for={option.id}>
            <input
                type="radio"
                name={name}
                value={option.value}
                id={option.id}
                bind:group={inputValue}
                on:click={handleValue}
                class="w-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600
                 dark:ring-offset-gray-800 focus:ring-2
                 dark:bg-gray-700 dark:border-gray-600 {disabled ? 'cursor-none' : 'cursor-pointer'}"
                disabled="{disabled}"
            >
            <span>{option.label}</span>
        </label>
    {/each}
</div>

{#if errorText}
    <div class="pl-3 text-red-500">{errorText}</div>
{/if}
